module.exports = __webpack_public_path__ + "static/media/warning.4041a48a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/warning.svg
// module id = 1494
// module chunks = 0